export const SIZE_OF_POWERED_BY = 22;
export const SIZE_OF_POWERED_BY_MOBILE = 19;
export const DEFAULT_HEADER_LINE_HEIGHT = 1.2;